
const React = require('react');
const ReactScriptLoaderMixin = require('react-script-loader').ReactScriptLoaderMixin;
const env = require('./utils/env').env;
const PaymentService = require('./services/payment').PaymentService;

const StripeButton = React.createClass({
    mixins: [ReactScriptLoaderMixin],

    getScriptURL: function() {
        return 'https://checkout.stripe.com/checkout.js';
    },

    statics: {
        updateHandler: null,
        scriptDidError: false,
    },

    // Indicates if the user has clicked on the button before the
    // the script has loaded.
    hasPendingClick: false,

    onScriptLoaded: function() {
        // Initialize the Stripe handler on the first onScriptLoaded call.
        // This handler is shared by all StripeButtons on the page.
        let _this = this;
        if (!StripeButton.updateHandler) {
            StripeButton.updateHandler = StripeCheckout.configure({
                key: env.getStripePublicKey(),
                image: 'https://stripe.com/img/documentation/checkout/marketplace.png',
                locale: 'auto',
                allowRememberMe: false,
                name: 'theFarmBoard',
                description: '',
                panelLabel: 'Update Payment Details',
                email: this.props.user.email,
                zipCode: true,
                token: function(token) {
                    // Use the token to create the charge with a server-side script.
                    _this.submitUpdateForm(token.id);
                }
            });
            if (this.hasPendingClick) {
                this.showStripeDialog();
            }
        }

    },
    showStripeDialog: function() {
            StripeButton.updateHandler.open({email: this.props.user.email});
    },
    onScriptError: function() {
        StripeButton.scriptDidError = true;
    },

    submitUpdateForm: function (token) {
        let _this = this;
        PaymentService.update(token, this.props.ID, function(err) {
            if (!err) {
                _this.setState({error: false});
                if (_this.props.onChange)
                    _this.props.onChange('PaymentActive', true);
                if (_this.props.onSuccess)
                    _this.props.onSuccess();
            } else {
                _this.setState({error: true});
            }
        });
    },
    
    onClick: function(event) {
        event.preventDefault();
        if (StripeButton.scriptDidError) {
            console.log('failed to load script');
        } else if (StripeButton.updateHandler) {
            this.showStripeDialog();
        } else {
            this.hasPendingClick = true;
        }
    },
    render: function() {
        const childrenWithProps = React.Children.map(this.props.children,
            (child) => React.cloneElement(child, {
                onClick: this.onClick
            })
        );

        return <div>{childrenWithProps}</div>;
    }
});

exports.StripeButton = StripeButton;